var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.667a.683.683 0 0 1-.473-.194l-4-4a.664.664 0 1 1 .94-.94L8 9.06l3.527-3.527a.664.664 0 1 1 .94.94l-4 4a.656.656 0 0 1-.467.194Z",
    fill: "#273943"
  })));
};
export default SvgChevronDown;